import type { AiAppCenterModule } from '../types'

export const courseModule: AiAppCenterModule = {
  key: 'course',
  label: 'AI课程培训系统',
  desc: '课程管理 / 学员管理 / 在线学习',
  path: '/course',
  homePath: '/course/dashboard',
  icon: 'ep:school',
  color: '#06b6d4',
  aliases: ['课程培训']
}
